// extracted by mini-css-extract-plugin
export default {"news":"News_news__d6Vrk","news__grid":"News_news__grid__m4J4z","card":"News_card__kKOlE","card__main":"News_card__main__Z+q0P","card__overlay":"News_card__overlay__QqR5s"};